import BaseService from "../BaseService";

class DebtService extends BaseService {
    getSummary = async () => {
        var data = await this._api.get(`/store/debt/summary`);
        return data;
    };

    list = async ({ from_date } = {}) => {
        var data = await this._api.post(`/store/debt/list`, { from_date });
        return data;
    };
}

export default DebtService;